<template>
  <div class="subpage">
    <div class="page-navbar">
      <div class="page-navbar-wrapper">
        <ul>
          <li
            :data-menuanchor="navbar.anchor"
            :key="i"
            @click="moveToSection(i)"
            v-for="(navbar, i) in pageNavbarItems"
          >
            <span>{{ navbar.name }}</span>
          </li>
        </ul>
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>
    </div>
    <full-page
      :options="options"
      id="fullpage"
      ref="fullpage"
      class="full-scrollable"
    >
      <div
        class="subpage-header section fp-auto-height-responsive"
        data-anchor="phev-history"
      >
        <div class="section-container">
          <div class="section-wrapper text-right">
            <h2
              class="uppercase header"
              data-aos="text-focus-in"
              data-aos-duration="500"
            >
              Dłuższa <span>historia</span>, większa ewolucja
            </h2>
            <p
              class="description"
              data-aos="text-focus-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              Mitsubishi Motors może pochwalić się długą i wspaniałą historią
              samochodów elektrycznych oraz rajdów, która rozpoczęła się ponad
              50 lat temu. Wykorzystując know-how i technologie pozyskane w
              wyniku nieustępujących prac badawczych w procesie produkcji
              samochodów, dążymy do osiągnięcia jak największej przyjemności z
              jazdy i maksymalnego bezpieczeństwa. Nasza najnowsza technologia
              hybrydowego napędu Plug-in to również efekt wielu lat
              doświadczenia i udoskonaleń napędu elektrycznego testowanego w
              wyczerpujących warunkach.
            </p>
            <!--<v-btn
              :class="'mmc-blue background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="300"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-blue' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=P0-AL7pylgA"
              ></span>
              <i class="fas fa-play"></i>
              Zobacz video
            </v-btn>-->
          </div>
        </div>
      </div>
      <div
        class="world-leader section fp-auto-height-responsive"
        data-anchor="world-leader"
      >
        <div class="section-container">
          <div class="section-wrapper text-center">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              Elektryczny i hybrydowy
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              Światowy pionier produkcji samochodów EV
            </h2>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              Marka Mitsubishi Motors od lat 70. XX wieku odgrywa istotną rolę w
              branży rozwoju samochodów elektrycznych. W 2009 roku koncern
              wprowadził na rynek i-MiEV, pierwszy samochód elektryczny
              produkowany na skalę masową, a w 2013 r. także Outlandera PHEV -
              pierwszego na świecie hybrydowego SUV-a* z napędem Plug-In.
            </p>
            <!--<v-btn
              :class="'mmc-red background'"
              class="gallery"
              data-aos="text-focus-in"
              data-aos-delay="450"
              data-aos-duration="1000"
              data-selector=".movie"
              v-ripple="{ class: 'ripple-red' }"
            >
              <span
                class="movie"
                data-src="https://www.youtube.com/watch?v=cRs3FilkroM"
              ></span>
              <i class="fas fa-play"></i>
              Zobacz wideo
            </v-btn>-->
            <div class="scroll-downs">
              <div class="mousey">
                <div class="scroller"></div>
              </div>
            </div>
            <p
              class="description margin"
              data-aos="zoom-in"
              data-aos-delay="600"
              data-aos-duration="500"
            >
              Przewiń w dół, aby poznać historię Eclipse Cross PHEV.
            </p>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/1.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1917</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Model A
              </h3>
              <p>
                Stanowił podwaliny produkcji samochodów - został wybrany przez
                organizację non-profit Japan Automotive Hall of Fame* (JAHFA),
                jako samochód Historia - ten, który odcisnął piętno doskonałości
                w historii japońskiej motoryzacji.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="timeline swap section fp-auto-height-responsive"
        data-anchor="*"
      >
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div
              class="timeline-description"
              data-aos="fade-right"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Model PX33
              </h3>
              <p>
                Pierwszy napęd 4X4.
              </p>
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1936</span
                >
              </p>
            </div>
            <div class="timeline-image">
              <img
                data-aos="fade-left"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/2.jpg')"
                alt="Mitsubishi"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/3.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1953</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Mitsubishi Jeep
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="timeline swap section fp-auto-height-responsive"
        data-anchor="*"
      >
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div
              class="timeline-description"
              data-aos="fade-right"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Historyczny model 500
              </h3>
              <div class="buttons">
                <v-btn
                  :class="'mmc-red background'"
                  class="gallery"
                  data-aos="text-focus-in"
                  data-aos-delay="300"
                  data-aos-duration="1000"
                  data-selector=".movie"
                  v-ripple="{ class: 'ripple-red' }"
                >
                  <span
                    class="movie"
                    data-src="https://www.youtube.com/watch?v=Acle0H3Jtkg"
                  ></span>
                  <i class="fas fa-play"></i>
                  Test
                </v-btn>
              </div>
              <div class="buttons">
                <v-btn
                  :class="'mmc-red background'"
                  class="gallery"
                  data-aos="text-focus-in"
                  data-aos-delay="300"
                  data-aos-duration="1000"
                  data-selector=".movie"
                  v-ripple="{ class: 'ripple-red' }"
                >
                  <span
                    class="movie"
                    data-src="https://www.youtube.com/watch?v=MNX_Iyn-jv0"
                  ></span>
                  <i class="fas fa-play"></i>
                  Design
                </v-btn>
              </div>
              <div class="buttons">
                <v-btn
                  :class="'mmc-red background'"
                  class="gallery"
                  data-aos="text-focus-in"
                  data-aos-delay="300"
                  data-aos-duration="1000"
                  data-selector=".movie"
                  v-ripple="{ class: 'ripple-red' }"
                >
                  <span
                    class="movie"
                    data-src="https://www.youtube.com/watch?v=Vz-Gfr35z5o"
                  ></span>
                  <i class="fas fa-play"></i>
                  Speed record
                </v-btn>
              </div>
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1959</span
                >
              </p>
            </div>
            <div class="timeline-image">
              <img
                data-aos="fade-left"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/4.jpg')"
                alt="Mitsubishi"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/5.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1971</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Minica Van EV
              </h3>
              <div class="buttons">
                <v-btn
                  :class="'mmc-red background'"
                  class="gallery"
                  data-aos="text-focus-in"
                  data-aos-delay="300"
                  data-aos-duration="1000"
                  data-selector=".movie"
                  v-ripple="{ class: 'ripple-red' }"
                >
                  <span
                    class="movie"
                    data-src="https://www.youtube.com/watch?v=Lwp7OUtn0ps"
                  ></span>
                  <i class="fas fa-play"></i>
                  Pierwszy samochód elektryczny
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/6.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1971</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Delica Van EV 4X4
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="timeline swap section fp-auto-height-responsive"
        data-anchor="*"
      >
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div
              class="timeline-description"
              data-aos="fade-right"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Pajero
              </h3>
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1982</span
                >
              </p>
            </div>
            <div class="timeline-image">
              <img
                data-aos="fade-left"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/7.jpg')"
                alt="Mitsubishi"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/8.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1991</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Lancer VAN EV
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="timeline swap section fp-auto-height-responsive"
        data-anchor="*"
      >
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div
              class="timeline-description"
              data-aos="fade-right"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Fto-ev
              </h3>
              <p>
                Rekord guinessa 2142.3km w 24h
              </p>
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >1999</span
                >
              </p>
            </div>
            <div class="timeline-image">
              <img
                data-aos="fade-left"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/9.jpg')"
                alt="Mitsubishi"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/10.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >2003</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Outlander I
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="timeline swap section fp-auto-height-responsive"
        data-anchor="*"
      >
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div
              class="timeline-description"
              data-aos="fade-right"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Outlander II
              </h3>
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >2006</span
                >
              </p>
            </div>
            <div class="timeline-image">
              <img
                data-aos="fade-left"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/11.jpg')"
                alt="Mitsubishi"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="timeline section fp-auto-height-responsive" data-anchor="*">
        <div class="subpage-container">
          <div class="subpage-wrapper">
            <div class="timeline-image">
              <img
                data-aos="fade-right"
                data-aos-duration="500"
                :src="require('@/assets/images/timeline/12.jpg')"
                alt="Mitsubishi"
              />
            </div>
            <div class="timeline-time">
              <p>
                <span
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="150"
                  >2013</span
                >
              </p>
            </div>
            <div
              class="timeline-description"
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <h3 class="uppercase">
                Outlander PHEV
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="section-background section fp-auto-height-responsive"
        data-anchor="DNA"
      >
        <div class="section-container">
          <div class="top-text">
            <p data-aos="fade-down" data-aos-duration="500">2021</p>
            <img
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
              :src="require('@/assets/images/logo-ec-phev.png')"
              alt="Outlander PHEV"
            />
          </div>
          <div class="section-wrapper">
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="300"
              data-aos-duration="500"
            >
              Rajdowe DNA Mitsubishi
            </h2>
            <p
              class="description"
              data-aos="zoom-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              Wiele technologii wprowadzonych przez Mitsubishi Motors wywodzi
              się prosto ze świata rajdów, a rozwój Lancera Evolution na
              przestrzeni ostatnich dwóch dekad jest najlepszym tego przykładem.
              Podejście nie zmieniło się również w przypadku najnowszego Eclipse
              Cross PHEV. Silnik spalinowy, silniki elektryczne, akumulator
              trakcyjny, układ sterowania napędem hybrydowym oraz napędem 4x4
              zostały udoskonalone i dopracowane, tworząc razem zespół napędowy,
              oferujący wdzięk, komfort oraz osiągi.
            </p>
          </div>
        </div>
      </div>
      <div
        class="footer section fp-auto-height-responsive"
        data-anchor="features"
      >
        <Footer></Footer>
      </div>
    </full-page>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FullPage from "vue-fullpage.js/src/FullPage";
import AOS from "aos";
import { mapGetters } from "vuex";

export default {
  name: "Timeline",
  data: function() {
    return {
      pageNavbarItems: [
        {
          name: "Historia PHEV",
          anchor: "phev-history"
        },
        {
          name: "Swiatowy pionier",
          anchor: "world-leader"
        }
      ],
      options: {
        licenseKey: "3AAF9650-2EB641C5-91E1ED66-B5D30F2B",
        scrollBar: true,
        verticalCentered: false,
        menu: ".page-navbar ul",
        responsiveWidth: 9999,
        responsiveHeight: 9999,
        scrollingSpeed: 0,
        paddingTop: 0,
        paddingBottom: 0,
        loopTop: true,
        loopBottom: true
      }
    };
  },
  computed: {
    ...mapGetters({
      header: "header"
    })
  },
  components: {
    Footer,
    FullPage
  },
  methods: {
    updateHomeHeaderSize() {
      this.header.homeHeaderYSize = document.querySelector(
        ".subpage-header"
      ).offsetHeight;
    },
    moveToSection(index) {
      this.$refs.fullpage.api.moveTo(index + 1);
    },
    refresh() {
      AOS.refresh();
    }
  },
  mounted() {
    const galleries = document.getElementsByClassName("gallery");
    const body = document.querySelector("body");

      Array.prototype.forEach.call(galleries, e => {
        window.lightGallery(e, {
          selector: e.getAttribute("data-selector"),
          download: false,
          autoplay: false,
          videoMaxWidth: "1920px"
        });
      });

    body.classList.remove("no-overflow");

    this.updateHomeHeaderSize();
    window.addEventListener("resize", this.updateHomeHeaderSize);

    setTimeout(() => {
      this.refresh();
    }, 2000);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHomeHeaderSize);
  }
};
</script>

<style scoped lang="scss">
@import "src/styles/mixins";
@import "src/styles/page-navbar";
@import "src/styles/footer-subpage";
@import "src/styles/section-background";

.subpage-header {
  @include display-flex(flex, wrap);
  @include set-background(no-repeat, center center, cover);
  background-image: url("../assets/images/timeline/header-background.png");
  padding: var(--page-offset);
  min-height: 100vh;
  align-content: center;

  .section-container {
    @include display-flex(flex, wrap);
    padding: var(--page-offset);
    align-content: center;
    justify-content: flex-end;

    .section-wrapper {
      width: 50%;

      @media screen and (max-width: $screen-md) {
        width: 75%;
      }

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }

      .header {
        span {
          color: $mmc-blue;
        }
      }

      .description {
        color: #c7d3de;
      }
    }
  }
}

.world-leader {
  &::after {
    @include set-position(absolute, auto, auto, 0, 50%);
    @include set-size(6.5rem, 22vh);
    transform: translateX(-50%);
    content: "";
    border: 2px solid $mmc-red;
    border-bottom: none;

    @media screen and (max-height: $screen-height-lg) {
      height: 7vh;
    }

    @media screen and (max-width: $screen-md) {
      height: 7vh;
    }

    @media screen and (max-width: $screen-md) and (orientation: landscape) {
      display: none;
    }

    @media screen and (max-width: $screen-sm) {
      display: none;
    }
  }

  &::before {
    @include set-position(absolute, 0, 0, auto, auto);
    @include set-size(223px, 3499px);
    @include set-background(no-repeat, right top, contain);
    content: "";
    background-image: url("../assets/images/timeline/ec-phev-text.png");

    @media screen and (max-width: $screen-sm) {
      @include set-size(157px, 2450px);
    }
  }

  .section-container {
    @include display-flex(flex, wrap);
    min-height: 100vh;
    align-content: center;
    padding: var(--page-offset) calc(2 * var(--page-offset));

    @media screen and (max-width: $screen-sm) {
      min-height: auto;
    }

    .header-sub {
      color: $mmc-blue;
    }

    .header {
      color: $black;
    }

    .scroll-downs {
      margin: 3rem auto 0;
    }

    .mousey {
      border-color: $mmc-red;
    }

    .scroller {
      background-color: $mmc-red;
    }

    .description {
      color: $slider-description;

      &.margin {
        margin: 3rem 0 0;
      }
    }
  }
}

.timeline {
  overflow: hidden;

  &.swap {
    .timeline-image {
      text-align: left !important;
    }

    .timeline-description {
      text-align: right !important;
    }

    .buttons {
      justify-content: flex-end !important;

      .v-btn {
        text-align: right;
      }
    }
  }

  .subpage-container {
    @include display-flex(flex, wrap);
    align-content: center;

    .subpage-wrapper {
      @include display-flex(flex, wrap);
      @include size-flex(100%);
      padding: var(--page-offset) calc(2 * var(--page-offset));
      position: relative;

      &::after {
        @include set-position(absolute, 0, 50%, auto, auto);
        @include set-size(6.5rem, 100vh);
        transform: translateX(50%);
        content: "";
        border-left: 2px solid $mmc-red;
        border-right: 2px solid $mmc-red;

        @media screen and (max-width: $screen-sm) {
          display: none;
        }
      }

      @media screen and (max-width: $screen-sm) {
        padding-top: 7rem;
      }

      .timeline-image {
        @include size-flex(40%);
        text-align: right;

        @media screen and (max-width: $screen-sm) {
          @include size-flex(100%);
        }

        img {
          max-width: 100%;

          @media screen and (max-width: $screen-sm) {
            margin-top: 1.5rem;
          }
        }
      }

      .timeline-time {
        @include size-flex(20%);
        background-color: $white;
        text-align: center;

        @media screen and (max-width: $screen-sm) {
          @include set-position(absolute, 1rem, auto, auto, 1rem);
          @include size-flex(100%);
          width: calc(100% - 2rem);
          background-color: transparent;
        }

        p {
          @include z-index(relative, 2);
          display: inline-block;

          &::after {
            @include set-position(absolute, -0.5rem, -1.5rem, -0.5rem, -1.5rem);
            content: "";
            background-color: $white;

            @media screen and (max-width: $screen-sm) {
              display: none;
            }
          }

          @media screen and (max-height: $screen-height-es) and (orientation: landscape) {
            width: 5rem;
          }

          @media screen and (max-width: $screen-md) and (orientation: landscape) {
            width: 5rem;
          }

          @media screen and (max-width: $screen-sm) {
            @include margin-padding(1rem 0, 1rem 0);
            border-top: 2px solid $mmc-red;
            border-bottom: 2px solid $mmc-red;
            display: block;
          }

          span {
            @include font-size-color(3rem, $mmc-red);
            @include z-index(relative, 2);
            margin: 0;
            line-height: 1;

            @media screen and (max-width: $screen-xl) {
              font-size: 2.4rem;
            }

            @media screen and (max-width: $screen-md) {
              font-size: 2.1rem;
            }
          }
        }
      }

      .timeline-description {
        @include size-flex(40%);

        @media screen and (max-width: $screen-sm) {
          @include size-flex(100%);
        }

        h3 {
          @include font-size-color(2.5rem, $black);
          font-weight: 900;
          margin: 0 0 1.5rem;
          line-height: 1;

          @media screen and (max-width: $screen-md) {
            font-size: 1.9rem;
          }

          @media screen and (max-width: $screen-sm) {
            margin-top: 1.5rem;
          }
        }

        p {
          @include font-size-color(0.85rem, $slider-description);
        }

        .buttons {
          @include display-flex(flex, wrap);
          justify-content: flex-start;
        }

        .v-btn {
          color: $mmc-red !important;
          box-shadow: none;
          border-color: transparent !important;
          background-color: transparent !important;
          padding: 0.5rem !important;
          max-width: 100% !important;
          white-space: pre-line;
          text-align: left;

          i {
            color: $mmc-red !important;
            font-size: 1rem;
            margin-right: 1rem;
          }
        }
      }
    }
  }
}

.section-background {
  overflow: hidden;

  .section-container {
    background-image: url("../assets/images/timeline/car-background.jpg");
    min-height: 100vh;
    align-content: inherit;

    .top-text {
      @include display-flex(flex, wrap);
      @include size-flex(100%);
      align-self: flex-start;

      @media screen and (max-height: $screen-height-es) {
        position: relative;
        top: 0;
        left: 0;
      }

      @media screen and (max-width: $screen-sm) {
        position: relative;
        top: 0;
        left: 0;
      }

      p {
        @include size-flex(100%);
        @include font-size-color(3rem, $mmc-blue);
        line-height: 1;
        margin-bottom: 2rem;
      }
    }

    .section-wrapper {
      @include display-flex(flex, wrap);
      @include size-flex(100%);
      align-self: flex-end;
    }

    &::after {
      display: none;
    }
  }
}
</style>
